import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { history } from '../store'
import AppTimeHeader from '../containers/AppTimeHeader'
import { withNamespaces } from "react-i18next"
import StepBarTime from '../components/StepBarTime'
import { CreditCard } from 'lucide-react'
import { postRedsys, fetchCustomer } from '../actions/qrstime'

class PaymentTimeView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      redsysSignature: null,
      redsysMerchant: null,
      redsysVersion: null,
      minutes: 5,
      seconds: 0,
      isTimeUp: false,
      iva: 21,
      importeBase: null,
      importeIva: null,
      total: null,
    }
  }

  getButtonStyle() {
    const { qrData } = this.props;
    const buttonColor1 = qrData?.headerConfig?.buttonColor1 || '#01315f';
    const buttonColor2 = qrData?.headerConfig?.buttonColor2 || '#067ddb';
    const buttonText = qrData?.headerConfig?.buttonText || '#ffffff';

    return {
      background: `linear-gradient(135deg, ${buttonColor1}, ${buttonColor2})`,
      color: buttonText,
      border: 'none'
    };
  }

  getPrimaryColor() {
    const { qrData } = this.props;
    return qrData?.headerConfig?.primaryColor || '#01315f';
  }

  componentDidMount() {
    const {
      zoneSelected, descriptionZone, selectedLocker, lockerPrice,
      totalMinutes, slotMinutes, slotCount, pricePerSlot,
      lockerAssigned, lockerMatricula, lockerCustomer, lockerCustomerID,
      qr, qrType, qrMode, phoneNumber, timeConfig,
    } = this.props.location.state;

    // Guard: if this locker already has a completed rental ticket, the user must not
    // re-enter the purchase flow (e.g. via browser back). Send them to the QR home view.
    const existingTicket = (() => { try { return JSON.parse(sessionStorage.getItem('vacway_time_ticket')); } catch { return null; } })();
    if (existingTicket && existingTicket.lockerAssigned === lockerAssigned) {
      history.replace(`/qrsale/${qr}`);
      return;
    }

    const { t, i18n } = this.props;

    // Calculate IVA
    const iva = 21;
    const total = lockerPrice;
    const importeBase = (total / (1 + iva / 100)).toFixed(2);
    const importeIva = (total - importeBase).toFixed(2);

    this.setState({ total, importeBase: parseFloat(importeBase), importeIva: parseFloat(importeIva) });

    // Start countdown
    this.startCountdown();

    // Redsys language map
    let language = '001';
    switch (i18n.language) {
      case 'es': language = '001'; break;
      case 'en': language = '002'; break;
      case 'it': language = '007'; break;
      case 'de': language = '005'; break;
      case 'fr': language = '004'; break;
      case 'pt': language = '009'; break;
      default: language = '002'; break;
    }

    const paymentId = Math.floor(Math.random() * 1000000 + 1).toString();
    const paymentDate = new Date().toISOString();

    const redsysURLOK = `https://lockers-qr.vacway.es/ticketTimeView?zoneSelected=${zoneSelected}&descriptionZone=${descriptionZone}&selectedLocker=${selectedLocker}&lockerPrice=${lockerPrice}&lockerAssigned=${lockerAssigned}&lockerMatricula=${lockerMatricula}&lockerCustomer=${lockerCustomer}&qrToken=${qr}&qrType=${qrType}&qrMode=${qrMode}&phoneNumber=${phoneNumber}&totalMinutes=${totalMinutes}&slotMinutes=${slotMinutes}&slotCount=${slotCount}&pricePerSlot=${pricePerSlot}&language=${i18n.language}&paymentId=${paymentId}&paymentDate=${encodeURIComponent(paymentDate)}&courtesyTime=${timeConfig?.courtesyTime || 5}`;
    const redsysURLKO = `https://lockers-qr.vacway.es/paymentTimeError?qr=${qr}&language=${i18n.language}`;

    let redsysPetition = {
      price: lockerPrice,
      redsysURLOK,
      redsysURLKO,
      paymentId,
      merchantCode: '351639505',
      currency: '978',
      terminal: '1',
      merchantUrl: 'https://vacway.com',
      secretKey: 'xhI+J4wrx0JKkeGqJ12j2+ErLNH9OpHM',
      language,
    };

    this.props.fetchCustomer(lockerCustomerID)
      .then((customer) => {
        if (customer.response?.Redsys) {
          redsysPetition.merchantCode = customer.response.Redsys.MERCHANTCODE;
          redsysPetition.currency = customer.response.Redsys.CURRENCY;
          redsysPetition.terminal = customer.response.Redsys.TERMINAL;
          redsysPetition.merchantUrl = customer.response.Redsys.MERCHANTURL;
          redsysPetition.secretKey = customer.response.Redsys.SECRETKEY;
        }

        this.props.postRedsys(redsysPetition)
          .then((answer) => {
            const answerRedsys = answer.response;
            this.setState({
              redsysSignature: answerRedsys.Ds_Signature,
              redsysMerchant: answerRedsys.Ds_MerchantParameters,
              redsysVersion: answerRedsys.Ds_SignatureVersion,
            });
          })
          .catch(console.error);
      })
      .catch(console.error);
  }

  componentWillUnmount() {
    clearInterval(this.countdownInterval);
  }

  startCountdown = () => {
    this.countdownInterval = setInterval(() => {
      if (this.state.seconds > 0) {
        this.setState(prev => ({ seconds: prev.seconds - 1 }));
      } else {
        if (this.state.minutes > 0) {
          this.setState(prev => ({ minutes: prev.minutes - 1, seconds: 59 }));
        } else {
          clearInterval(this.countdownInterval);
          this.setState({ isTimeUp: true });
        }
      }
    }, 1000);
  }

  render() {
    const { t } = this.props;
    const { redsysSignature, redsysMerchant, redsysVersion, minutes, seconds, isTimeUp, total, importeBase, importeIva, iva } = this.state;
    const primaryColor = this.getPrimaryColor();
    const buttonStyle = this.getButtonStyle();

    const {
      selectedLocker, totalMinutes, lockerMatricula, lockerPrice, timeConfig
    } = this.props.location.state;

    const hours = Math.floor(totalMinutes / 60);
    const mins = totalMinutes % 60;
    const timeDisplay = hours > 0 ? (mins > 0 ? `${hours}h ${mins}min` : `${hours}h`) : `${mins}min`;

    if (isTimeUp) {
      return (
        <div className="timeBackground">
          <AppTimeHeader />
          <div className="time-page-wrap">
            <div className="time-content time-center">
              <img src="/images/timeout.svg" alt="Timeout" className="time-timeout-img" />
              <h3>{t('Tiempo agotado')}</h3>
              <p>{t('El tiempo para completar el pago ha expirado. Por favor, vuelve a intentarlo.')}</p>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="timeBackground">
        <AppTimeHeader />
        <div className="time-page-wrap">
          <div className="time-content time-locker-selector-wide">
            <div className="time-page-header">
              <div className="time-page-header-icon" style={buttonStyle}>
                <CreditCard size={24} strokeWidth={2} />
              </div>
              <div className="time-page-header-text">
                <h2>{t('Resumen y Pago')}</h2>
                <p>{t('Revisa tu reserva y completa el pago de forma segura')}</p>
              </div>
              <span className="time-page-header-step">4 / 5</span>
            </div>

            <div className="time-payment-timer" style={{ borderColor: primaryColor }}>
              <span>{t('Tiempo para pagar')}</span>
              <strong style={{ color: minutes < 1 ? '#e74c3c' : primaryColor }}>
                {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
              </strong>
            </div>

            <div className="time-summary-card" style={{ borderColor: primaryColor }}>
              <div className="time-summary-row">
                <span>{t('Taquilla')}</span>
                <strong>{selectedLocker}</strong>
              </div>
              <div className="time-summary-row">
                <span>{t('Matrícula')}</span>
                <strong>{lockerMatricula}</strong>
              </div>
              <div className="time-summary-row">
                <span>{t('Tiempo alquilado')}</span>
                <strong>{timeDisplay}</strong>
              </div>
              <div className="time-summary-row">
                <span>{t('Cortesía')}</span>
                <strong>+{timeConfig?.courtesyTime || 5} min</strong>
              </div>
              <div className="time-summary-divider"></div>
              <div className="time-summary-row">
                <span>{t('Base imponible')}</span>
                <strong>{importeBase ? importeBase.toFixed(2) : '--'} €</strong>
              </div>
              <div className="time-summary-row">
                <span>{t('IVA')} ({iva}%)</span>
                <strong>{importeIva ? importeIva.toFixed(2) : '--'} €</strong>
              </div>
              <div className="time-summary-divider"></div>
              <div className="time-summary-row time-summary-total">
                <span>{t('TOTAL')}</span>
                <strong>{total ? total.toFixed(2) : '--'} €</strong>
              </div>
            </div>

            {redsysSignature && redsysMerchant && redsysVersion ? (
              <form
                action="https://sis.redsys.es/sis/realizarPago"
                method="POST"
                className="time-redsys-form"
              >
                <input type="hidden" name="Ds_SignatureVersion" value={redsysVersion} />
                <input type="hidden" name="Ds_MerchantParameters" value={redsysMerchant} />
                <input type="hidden" name="Ds_Signature" value={redsysSignature} />

                <button type="submit" className="time-pay-btn" style={buttonStyle}>
                  <span className="time-pay-icon">💳</span>
                  {t('PAGAR')} {total ? total.toFixed(2) : '--'} €
                </button>
              </form>
            ) : (
              <div className="time-loading-payment">
                <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>
                <p>{t('Preparando pasarela de pago...')}</p>
              </div>
            )}

          </div>
        </div>
        <StepBarTime step={4} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: true,
  qrData: state.qrs.qr
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
  postRedsys: bindActionCreators(postRedsys, dispatch),
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch),
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(PaymentTimeView));
